import { COLOR_MODE } from 'theme/appColorMode';
import appDarkTheme from 'theme/appDarkTheme';
import appLightTheme from 'theme/appLightTheme';

export function createAppTheme(mode) {
  return mode === COLOR_MODE.DARK ? appDarkTheme : appLightTheme;
}

export { appDarkTheme, appLightTheme };
